export default __webpack_public_path__ + "static/media/phubd_deactive.3f69deda.svg";